// Shared reader for the "jump back to the estimate I was just on" pointer
// (written by EstimateDetail.jsx on every project/tab visit). Both Nav.jsx
// (to render the back-link) and useNavHeight.js (to reserve layout space
// for it) need the exact same value, so it lives in one place.
export function getLastEstimate() {
  try {
    const raw = localStorage.getItem("cs-last-estimate");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function isOnLastEstimate(lastEstimate, pathname) {
  return !!lastEstimate && pathname.startsWith(`/estimates/${lastEstimate.projectId}`);
}
